// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wealth"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M7.75 3.5H16.25V5.25C16.25 7.59721 14.3472 9.5 12 9.5C9.65279 9.5 7.75 7.59721 7.75 5.25V3.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 9.5C7.58172 9.5 4 13.0817 4 17.5V18C4 19.6569 5.34315 21 7 21H13M12 9.5C15.0136 9.5 17.638 11.1663 19.0021 13.6278M12 9.5C9.65279 9.5 7.75 7.59721 7.75 5.25V3.5H16.25V5.25C16.25 7.59721 14.3472 9.5 12 9.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17 17H22M17 21H22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WealthIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wealth',
    ref,
    icon: element,
  },
));

WealthIcon.displayName = 'WealthIcon';

export default WealthIcon;
